import {SpyneTrait, DomElement} from 'spyne';
import {SkeletonView} from 'components/skeleton-view';

export class PageLoadingSkeletonTraits extends SpyneTrait {

  constructor(context){
    let traitPrefix = "pageSkeleton$";

    super(context, traitPrefix);
  }

  static pageSkeleton$getTopMostVisibleElement(nodeList) {
    const arr =
        nodeList instanceof NodeList || Array.isArray(nodeList)
            ? Array.from(nodeList)
            : [nodeList];
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    const visibleEls = arr
    .map((el) => ({
      el,
      rect: el.getBoundingClientRect(),
    }))
    .filter(({ rect }) => {
      return (
          rect.bottom > 0 &&
          rect.top < viewportHeight &&
          rect.right > 0 &&
          rect.left < viewportWidth &&
          rect.width > 0 &&
          rect.height > 0
      );
    })
    .sort((a, b) => Math.max(a.rect.top, 0) - Math.max(b.rect.top, 0));
    return visibleEls[0]?.el;
  }

  static pageSkeleton$LoadSkeleton(skeletonCloneSel, offsets = { x: 0, y: -58, height: 530, width: 0 }, color = '#DCE3EB') {

    if (!this.props || !this.props.el$(skeletonCloneSel).exists){
      return;
    }

    // .els (not .el): the selector matches every reference container, and
    // pageSkeleton$getTopMostVisibleElement picks the visible one from the
    // list — .el returned only the first, so the skeleton was positioned
    // from the wrong container.
    const skeletonCloneList = this.props.el$(skeletonCloneSel).els;
    // { x: 264, y: -86, height: 330, width: 0 } DCE3EB
    const skeletonClone = this.pageSkeleton$getTopMostVisibleElement(skeletonCloneList);

    //console.log('skel clone ', {skeletonClone, skeletonCloneSel})

    if (!skeletonClone || typeof skeletonClone.getBoundingClientRect !== 'function') {
      return;
    }

    const {
      x: offsetX = 0,
      y: offsetY = 0,
      height: offsetHeight = 0,
      width: offsetWidth = 0,
    } = offsets || {};

    const rect = skeletonClone.getBoundingClientRect();

      const skeletonId = `page-skeleton-${Date.now()}`;

    const skeletonEl = document.createElement('div');
    skeletonEl.setAttribute('data-page-skeleton-id', skeletonId);
    skeletonEl.classList.add('ui-skeleton');

    const setCssTest = ()=>{
      skeletonEl.style.cssText = `
      position: absolute;
      top: ${rect.top + offsetY}px;
      left: 255px;
      width: ${rect.width + offsetWidth}px;
      height: ${rect.height + offsetHeight}px;
      background: ${color};
      border-radius: 4px;
      pointer-events: none;
      z-index: 99999;
    `;
    }

    setCssTest();

    const getCssText = ()=>{
      return`
      position: absolute;
      top: ${rect.top + offsetY}px;
      left: 255px;
      width: ${rect.width + offsetWidth}px;
      height: ${rect.height + offsetHeight}px;
      background: ${color};
      border-radius: 4px;
      pointer-events: none;
      z-index: 99999;
    `;
    };

    new SkeletonView({
      skeletonId,
      class: 'ui-skeleton',
      style: getCssText()

    }).appendToDom(document.querySelector("#page-container"))


    //requestAnimationFrame(setCssTest)




    //document.querySelector('#page-container').appendChild(skeletonEl);
    //console.log('skeleton el ',{skeletonEl, skeletonId});

   // const addClassReveal = ()=>skeletonEl.classList.add('reveal');
   // requestAnimationFrame(addClassReveal)
   // window.setTimeout(addClassReveal, 33);

    this.props.skeletonId = skeletonId;

    return skeletonId;
  }

  static pageSkeleton$RemoveSkeleton(skeletonId=this.props.skeletonId) {

    if (!skeletonId) {
      return;
    }

    const skelSel = `[data-page-skeleton-id="${skeletonId}"]`;

   // const skeletonEl = document.querySelector(skelSel);
    //console.log('skeleton id is ',{skeletonId,skelSel, skeletonEl})

    //skeletonEl.classList.remove('reveal');

    const onRemove = ()=>{

      if (skeletonEl) {
       // skeletonEl.remove();
      }

    }

    //window.setTimeout(onRemove, 500);

  }

}

